module.exports = __webpack_public_path__ + "img/18.5a391e74.jpg";